import React, { useContext } from "react";
import { AuthContext } from '../context/AuthContext';
import api from "../utils/api";
import "./DoctorSidebar.css";

const DoctorSidebar = ({ isOpen, toggleSidebar }) => {
  const { doctorUser, logout } = useContext(AuthContext); // Removed triggerAuthLoading

  const handleLogout = async () => {
    if (!doctorUser) {
      logout('doctor');
      window.location.href = "/doctor-login";
      return;
    }
    try {
      await api.post("/auth/logout", {}, {
        headers: { Authorization: `Bearer ${doctorUser.accessToken}` },
      });
      logout('doctor');
      window.location.href = "/doctor-login";
    } catch (error) {
      console.error("Logout failed:", error);
      logout('doctor');
      window.location.href = "/doctor-login";
    }
  };

  const menuItems = [
    { label: "Dashboard", path: doctorUser ? `/doctor-dashboard/${doctorUser.id}` : "/doctor-login", icon: "🏠" },
    { label: "Appointments", path: "/doctor-appointments", icon: "📅" },
    { label: "Patients", path: "/doctor-patients", icon: "👥" },
    { label: "Video Consultation", path: "/doctor-video-consultation", icon: "📹" },
    { label: "Earnings & Payments", path: "/doctor-earnings", icon: "💰" },
    { label: "Reviews & Feedback", path: "/doctor/feedback", icon: "⭐" },
    { label: "Profile Management", path: "/doctor-profile", icon: "👤" },
    { label: "Logout", action: handleLogout, icon: "🚪" },
  ];

  const handleRedirect = (item) => {
    if (item.action) {
      item.action();
      return;
    }

    const path = !doctorUser ? "/doctor-login" : item.path;

    // Navigate instantly
    window.location.href = path;

    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  return (
    <div className={`doctor-sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <h2>Doctor Portal</h2>
      </div>
      <ul className="sidebar-menu">
        {menuItems.map((item, index) => (
          <li key={index} className="sidebar-item">
            <button
              onClick={() => handleRedirect(item)}
              className="sidebar-button"
            >
              <span className="sidebar-icon">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DoctorSidebar;